import { getValidationMessages } from 'utils/validation'

const { INVALID_EMAIL, INVALID_PHONE_NUMBER } = getValidationMessages()

export enum AFTER_SUBMIT {
  CreateNew = 'CREATE_NEW',
  GoUrl = 'GO_URL',
}

export const INVALID_CONTACT_PERSON = Object.freeze({
  email: INVALID_EMAIL,
  mobile: INVALID_PHONE_NUMBER,
})

export const DUP_CHECK_ERRORS = {
  EXACT_DUP_NAME: 'lead_duplicate_contact_name_error',
  EXACT_DUP_EMAIL: 'lead_duplicate_email_error',
  EXACT_DUP_MOBILE: 'lead_duplicate_mobile_number_error',
  EXACT_DUP_COMPANY_NAME: 'lead_duplicate_company_error',
  EXACT_DUP_REGISTRATION: 'duplicate_found_registration_lbl',
  EXACT_DUP_URL: 'duplicate_found_with_website_lbl',
  POTENTIAL_DUP_NAME: 'duplicates_potential_contact_person_error',
  POTENTIAL_DUP_EMAIL: 'duplicates_potential_email_error',
  POTENTIAL_DUP_MOBILE: 'duplicates_potential_mobile_number_error',
  POTENTIAL_DUP_REGISTRATION: 'duplicates_potential_reg_no_error',
  POTENTIAL_DUP_COMPANY_NAME: 'duplicates_potential_company_error',
  POTENTIAL_DUP_URL: 'potential_duplicate_found_with_website_lbl',
}

export const DUPLICATE_MESSAGE = {
  name: {
    exact: DUP_CHECK_ERRORS.EXACT_DUP_NAME,
    potential: DUP_CHECK_ERRORS.POTENTIAL_DUP_NAME,
  },
  email: {
    exact: DUP_CHECK_ERRORS.EXACT_DUP_EMAIL,
    potential: DUP_CHECK_ERRORS.POTENTIAL_DUP_EMAIL,
  },
  mobile: {
    exact: DUP_CHECK_ERRORS.EXACT_DUP_MOBILE,
    potential: DUP_CHECK_ERRORS.POTENTIAL_DUP_MOBILE,
  },
  companyName: {
    exact: DUP_CHECK_ERRORS.EXACT_DUP_COMPANY_NAME,
    potential: DUP_CHECK_ERRORS.POTENTIAL_DUP_COMPANY_NAME,
  },
  registrationNumber: {
    exact: DUP_CHECK_ERRORS.EXACT_DUP_REGISTRATION,
    potential: DUP_CHECK_ERRORS.POTENTIAL_DUP_REGISTRATION,
  },
  website: {
    exact: DUP_CHECK_ERRORS.EXACT_DUP_URL,
    potential: DUP_CHECK_ERRORS.POTENTIAL_DUP_URL,
  },
}
